import { Injectable } from '@angular/core';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';

@Injectable({
  providedIn: 'root',
})
export class CustomFilterService {
  getCellValue(filterParams: IFilterParams, doesFilterParams: IDoesFilterPassParams): number {
    const { api, colDef, column, columnApi, context, valueGetter } = filterParams;
    const { node } = doesFilterParams;
    return valueGetter({
      api,
      colDef,
      column,
      columnApi,
      context,
      data: node.data,
      getValue: (field) => node.data[field],
      node,
    });
  }
}
